var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 20",
    style: {
      enableBackground: "new 0 0 16 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4B34FB;}\r\n\t.st1{fill:none;stroke:#4B34FB;stroke-linecap:round;}\r\n\t.st2{fill:#4B34FB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,7.7c0.1-0.1,0-0.2,0-0.3L9.2,5.7C9.1,5.7,9,5.7,9,5.8C8.9,5.9,8.9,6,9,6l2.4,1.7 C11.5,7.8,11.6,7.8,11.7,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.3,10.6c-0.1-0.1-0.2-0.1-0.3,0l-2.4,1.7c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.1,0.2,0.1,0.3,0l2.4-1.7 C12.3,10.8,12.3,10.7,12.3,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.3,7.7c0.1,0.1,0.2,0.1,0.3,0L7,6C7.1,6,7.1,5.9,7,5.8C7,5.7,6.9,5.7,6.8,5.7L4.4,7.5 C4.3,7.5,4.3,7.7,4.3,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.2,6c0.1,0,0.2-0.1,0.2-0.2V4c0-0.1,0-0.1-0.1-0.2L8.1,2.4c-0.1,0-0.1,0-0.2,0L5.7,3.9C5.6,3.9,5.6,4,5.6,4 v1.8C5.6,5.9,5.7,6,5.8,6c0.1,0,0.2-0.1,0.2-0.2V4.4l1.9,1.2v1.8l-1-0.6c-0.1-0.1-0.2,0-0.3,0.1C6.5,6.9,6.6,7,6.6,7.1l1.3,0.8 C8,8,8,8,8.1,7.9l1.3-0.8C9.4,7,9.5,6.9,9.4,6.8C9.4,6.7,9.2,6.7,9.2,6.8l-1,0.6V5.6l1.9-1.2v1.4C10.1,5.9,10.1,6,10.2,6z M8,5.3 L6.1,4L8,2.8L9.9,4L8,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.4,13.7c0-0.1,0-0.1-0.1-0.2l-2.2-1.5c-0.1,0-0.1,0-0.2,0l-2.2,1.5c-0.1,0-0.1,0.1-0.1,0.2V16 c0,0.1,0,0.1,0.1,0.2l2.2,1.5c0.1,0,0.1,0,0.2,0l2.2-1.5c0.1,0,0.1-0.1,0.1-0.2V13.7z M7.8,17.1l-1.9-1.2v-1.8l1.9,1.2V17.1z M8,15 l-1.9-1.3L8,12.5l1.9,1.3L8,15z M10.1,15.9l-1.9,1.2v-1.8l1.9-1.2V15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.4,11.3l2.2,1.5c0.1,0,0.1,0,0.2,0l1.3-0.8c0.1-0.1,0.1-0.2,0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1l-1,0.6v-1.8 l1.9-1.2v1.4c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2V8.9c0-0.1,0-0.1-0.1-0.2L2.9,7.2c-0.1,0-0.1,0-0.2,0L0.4,8.7 c-0.1,0-0.1,0.1-0.1,0.2v2.2C0.4,11.2,0.4,11.2,0.4,11.3z M2.8,7.6l1.9,1.3l-1.9,1.3L0.9,8.9L2.8,7.6z M0.7,9.2l1.9,1.2v1.8L0.7,11 V9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.6,8.7l-2.2-1.5c-0.1,0-0.1,0-0.2,0l-2.2,1.5c-0.1,0-0.1,0.1-0.1,0.2v1.8c0,0.1,0.1,0.2,0.2,0.2 c0.1,0,0.2-0.1,0.2-0.2V9.2l1.9,1.2v1.8l-1-0.6c-0.1-0.1-0.2,0-0.3,0.1c-0.1,0.1,0,0.2,0.1,0.3l1.3,0.8c0.1,0,0.1,0,0.2,0l2.2-1.5 c0.1,0,0.1-0.1,0.1-0.2V8.9C15.6,8.8,15.6,8.8,15.6,8.7z M13.2,10.1l-1.9-1.3l1.9-1.3l1.9,1.3L13.2,10.1z M15.3,11l-1.9,1.2v-1.8 l1.9-1.2V11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.7,10.6c-0.1,0.1,0,0.2,0,0.3l2.4,1.7c0.1,0.1,0.2,0,0.3,0c0.1-0.1,0-0.2,0-0.3L4,10.6 C3.9,10.5,3.8,10.6,3.7,10.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo3);
export default __webpack_public_path__ + "static/media/gamelogo3.8dc1868737adbfe86b6a64b6e1627987.svg";
export { ForwardRef as ReactComponent };